/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OnHoldDto } from './onHoldDto';
import { ActivityDto } from './activityDto';

export interface WorkOrderDto {
  id?: string;
  workOrderNumber?: string;
  title?: string;
  workCenterId?: string;
  projectId?: string;
  statusName?: string;
  siteNo?: string;
  division?: WorkOrderDto.DivisionEnum;
  startDate?: string;
  endDate?: string;
  status?: WorkOrderDto.StatusEnum;
  estimatedHours?: number;
  actualHours?: number;
  actualMinutesUsed?: number;
  progress?: number;
  weeksProgress?: number;
  released?: boolean;
  releasedToAll?: boolean;
  isAssigned?: boolean;
  closed?: boolean;
  onHold?: Array<OnHoldDto>;
  isFavourite?: boolean;
  activity?: ActivityDto;
  commentCount?: number;
  weightLineSentCount?: number;
  weightLineTotalCount?: number;
}
export namespace WorkOrderDto {
  export const DivisionEnum = {
    Sls: 'SLS',
    Fabrication: 'FABRICATION',
    Offshore: 'OFFSHORE',
  } as const;
  export type DivisionEnum = (typeof DivisionEnum)[keyof typeof DivisionEnum];
  export const StatusEnum = {
    Unreleased: 'UNRELEASED',
    Released: 'RELEASED',
    Assigned: 'ASSIGNED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
